import { RootState } from '../../../base';

export const scheduleInterviewSelectors = {
    getScheduleInterviewData: (state: RootState) =>
        state.scheduleInterview.data,
    getScheduleInterviewError: (state: RootState) =>
        state.scheduleInterview.error,
    getIsFetchLoading: (state: RootState) =>
        state.scheduleInterview.uiState.isFetchLoading,
    getIsSubmitLoading: (state: RootState) =>
        state.scheduleInterview.uiState.isSubmitLoading,
};
